const breakpoints = {
  desktop: 1024,
  tablet: 768,
  mobile: 520,
};

export const maxBreakpoint = (breakpoint: keyof typeof breakpoints) =>
  `@media (max-width: ${breakpoints[breakpoint]}px)`;

export const minBreakpoint = (breakpoint: keyof typeof breakpoints) =>
  `@media (min-width: ${breakpoints[breakpoint] + 1}px)`;
